<!-- <h2>Steps</h2> -->
<div class="steps-card">
  <div id="ppl-steps" class="steps-head">
    <nz-steps [nzCurrent]="currentStep" nzDirection="vertical" class="main-steps">
      <nz-step *ngFor="let step of availableSteps"
        pplKeyboardSelect [nzTitle]="getSteps(step.step_id)?.step_name" [nzStatus]="getStepStatus(step.step_id)"
        (click)="goToStep(step.step_id)" (selected)="goToStep(step.step_id)" (keyboardSelected)="onStepKeyboardSelect($event, step.step_id)">
      </nz-step>
    </nz-steps>
  </div>
  <div #footerButtons class="steps-footer">
    <p class="steps-tips">
      <i class="fa fa-info-circle" aria-hidden="true"></i> Once you have completed a section you can go back to view or
      edit from here. Fields marked with an <span style="color: red;">*</span> are required to move on to the next
      section.
    </p>

  @if(!isFormValid() && onSummary){
    <p><strong>Please ensure all mandatory steps are filled out before submitting.</strong></p>
  }
    <div class="d-flex justify-content-between">
      <div>
        @if(currentStep>0) {
        <ppl-button label="Previous" icon="fa fa-chevron-left" [customClass]="'ghost-button'" [iconPosition]="'left'"
          (click)="prev()"></ppl-button>
        }
      </div>
      <div>
        @if(!onSummary) {
          @if(flow === 'participantEnrollment' || flow === 'providerEnrollment'){
            <ppl-button label="Save and Next" icon="fa fa-chevron-right" [customClass]="'alt-button'" [iconPosition]="'right'"
            (click)="next()"></ppl-button>
          }
          @else{
            <ppl-button label="Next" icon="fa fa-chevron-right" [customClass]="'alt-button'" [iconPosition]="'right'"
            (click)="next()"></ppl-button>
          }
        }
        @else {
        @if(flow === 'referral') {
        <ppl-button label="Submit" icon="fa fa-check-circle" [customClass]="'primary-button'" [iconPosition]="'right'"
          [disabled]="!isFormValid()" (click)="submit('SAVE')"></ppl-button>
        }
        @else {
        <ppl-button label="Submit" icon="fa fa-check-circle" [customClass]="'primary-button'" [iconPosition]="'right'"
          [disabled]="!isFormValid()" (click)="submit()"></ppl-button>
        }
        }
      </div>
    </div>
    @if(onSummary && flow === 'referral') {
    <div class="mt-2">
      <ppl-button label="Submit and Approve" icon="fa fa-check-circle" [customClass]="'primary-button w-100'" [iconPosition]="'right'"
        [disabled]="!isFormValid()" (click)="submit('SUBMIT_APPROVE')"></ppl-button>
    </div>
    }
  </div>
</div>